"use client";

import { createCloudfrontLoader } from "@login/utils/image/loader";

const cloudfrontLoader = createCloudfrontLoader(process.env.NEXT_PUBLIC_IMAGES_URL);

export default cloudfrontLoader;
